export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
    if (location.state && location.state.preventScroll === true) {
        return false;
    }

    if (location.hash) {
        window.history.scrollRestoration = 'auto';
        return true;
    }

    window.history.scrollRestoration = 'manual';

    if (window.matchMedia('(max-width: 768px)').matches && location.action !== 'POP') {
        const scrollToTop = () => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        };

        window.requestAnimationFrame(() => {
            scrollToTop();
            window.setTimeout(scrollToTop, 150);
        });

        return false;
    }

    const currentPosition = getSavedScrollPosition(location, location.key);
    const top = currentPosition ? currentPosition[1] : 0;

    const scrollToPosition = () => {
        try {
            window.scrollTo({ top, behavior: 'instant' });
        } catch (e) {
            window.scrollTo(top);
        }
    };

    window.setTimeout(() => {
        window.requestAnimationFrame(() => {
            scrollToPosition();
            window.requestAnimationFrame(scrollToPosition);
        });
    }, 0);

    return false;
};